import React from 'react'

import './Home.css'

const Home = () => {
    return (
        <div className='page-height'>
            <div className='contain-bg'>
                <img id='home-pg-bg' src='images/Teddy/TRI_6495.jpg' alt='Teddy' />
            </div>
        </div>
    )
}

export default Home